//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DialogsAdmUmisteniSpisovyUzel.ts						</Name>
//    <Description> Funkce pro otev�en� dialog� spojen�ch s Um�st�n� dokument� pro SU </Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-10-06                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(sslsumi) GID:(Web.Dia.Ts) V1:(ixs_su,umisteni,umisteni_nad,aktivita,poznamka,dat_zmena,zmenu_prov,umisteni_txt,priz_oper,ixs_fun_zodp) V2:() K1:() K2:() K3:() ]

namespace Gordic.Adm.Dialogs {

    // AdmUmisteniSpisovyUzel
    export function DetailAdmUmisteniSpisovyUzelDlg(
        parentContent: GContent,
        opt: {
            /** ixs_su */
            ixs_su: string | null,
            /** umisteni */
            umisteni: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** p��znak nov�ho z�znamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;
    var detailCommand = opt.grid ? false : true;

    // grid remote control, kv�li �ipk�m na detailu
    const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

    var detail = ['Gordic.Adm.WebControls.DetailAdmUmisteniSpisovyUzel', { gridRemoteControl: gridRemoteControl }]

    const options = {
        ID: "AdmAdmUmisteniSpisovyUzel#",
        ixs_su: opt ? opt.ixs_su : undefined,
        umisteni: opt ? opt.umisteni : undefined,
        newRecord: opt ? opt.newRecord : undefined,
        detailCommand: detailCommand
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
}

    // AdmUmisteniSpisovyUzel
    export function SeznamAdmUmisteniSpisovyUzelDlg(
        parentContent: GContent,
        opt: {
            /** ixs_su */
            ixs_su: string | null,
            /** umisteni */
            umisteni: string | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;

    var detail = ['Gordic.Adm.WebControls.SeznamAdmUmisteniSpisovyUzel', { }]

    const options = {
        ID: "AdmAdmUmisteniSpisovyUzel#",
        ixs_su: opt ? opt.ixs_su : undefined,
        umisteni: opt ? opt.umisteni : undefined,
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
  }

}
